function CartReload(data) {
  const container = document.getElementById("cart-table");
  const tT = document.getElementById("total-top");
  const c = document.querySelector(".cart-table");
  const tB = document.getElementById("total-bottom");

  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, "text/html");
  const nTT = htmlDocument.documentElement.querySelector("#total-top");
  const nC = htmlDocument.documentElement.querySelector(".cart-table");
  const nTB = htmlDocument.documentElement.querySelector("#total-bottom");

  // 🧼 Clear old cartMain and cartExtras
  const oldMain = c.querySelector("#cart-main");
  if (oldMain) oldMain.remove();

  const oldExtras = c.querySelector("#cart-extras");
  if (oldExtras) oldExtras.remove();

  // 🧱 Create new
  const cartMain = document.createElement("div");
  cartMain.id = "cart-main";

  const cartExtras = document.createElement("div");
  cartExtras.id = "cart-extras";
  cartExtras.innerHTML = `<h4 style="text-align: center;">${window.translations.additional_items}</h4>`;

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // 🚀 Быстрый поиск: создаем индекс элементов для O(1) поиска
      const elementsByProductId = new Map();
      nC.querySelectorAll('[data-product-id]').forEach(element => {
        const productIds = element.getAttribute('data-product-id');
        elementsByProductId.set(productIds, element);
      });

      cart.items.forEach((item) => {
        const productId = item.variant_id.toString();
        
        // Быстрый поиск: сначала пробуем найти точное совпадение
        let productElement = null;
        for (const [dataProductId, element] of elementsByProductId) {
          if (dataProductId && dataProductId.includes(productId)) {
            productElement = element;
            elementsByProductId.delete(dataProductId); // Удаляем, чтобы избежать дубликатов
            break;
          }
        }

        if (productElement) {
          const isAutoAdded = item.properties?._auto_added === "true";

          if (isAutoAdded) {
            productElement.querySelectorAll(".qtybtn").forEach((btn) => {
              btn.setAttribute("disabled", "disabled");
              btn.style.opacity = "0.5";
              btn.style.cursor = "not-allowed";
            });

            const input = productElement.querySelector(".item-qty");
            if (input) {
              input.setAttribute("readonly", "readonly");
              input.style.opacity = "0.5";
              input.style.cursor = "not-allowed";
            }

            const removeLink = productElement.querySelector(".remove_item_multi");
            if (removeLink) removeLink.remove();

            const forms = productElement.querySelectorAll('form[action="/cart/change"]');
            forms.forEach((form) => {
              const input = form.querySelector('input[name="quantity"]');
              if (input?.value === "0") {
                form.addEventListener("submit", (e) => {
                  e.preventDefault();
                  alert("This item cannot be removed.");
                });
              }
            });

            cartExtras.appendChild(productElement);
          } else {
            cartMain.appendChild(productElement);
          }
        } else {
          console.warn(`⚠️ Product ${productId} not found`);
        }
      });

      // 🧼 Cart
      c.replaceChildren();

      c.appendChild(cartMain);

      if (cartExtras.childElementCount > 1) {
        c.appendChild(cartExtras);
      }

      // Renew summ
      if (nTT && tT) tT.replaceWith(nTT);
      if (nTB && tB) tB.replaceWith(nTB);

      const fullForm = container.querySelector(".full-form");
      const emptyForm = container.querySelector(".empty-form");
      if (fullForm && emptyForm) {
        fullForm.classList.remove("hidden");
        emptyForm.classList.add("hidden");
      }

      if (typeof imageObserver === "function") {
        imageObserver();
      } else {
        console.warn("⚠️ Lazyload is not active");
      }

      Quantity(container);
      CartButtons();
    })
    .catch((error) => {
      console.error("❌ Cart load error:", error);
      c.innerHTML = nC.innerHTML;
    });
}

// ================================================================
// debounce с методом cancel
// wait увеличен до 1000ms — чтобы не срабатывал пока пользователь
// ещё набирает число (например, 1000 = 4 нажатия)
// ================================================================
function debounce(fn, wait = 1000) {
  let t;
  function debounced(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  }
  debounced.cancel = () => clearTimeout(t);
  return debounced;
}

// ================================================================
// Флаг защиты от параллельных вызовов CartChange
// Без него: Enter + debounce запускают два процесса одновременно,
// оба удаляют auto-added и пересчитывают — появляются дубли
// ================================================================
let __CART_CHANGE_IN_PROGRESS__ = false;

async function CartChange(q, container) {
  if (__CART_CHANGE_IN_PROGRESS__) {
    console.warn('⚠️ CartChange already in progress, skipping');
    return;
  }
  __CART_CHANGE_IN_PROGRESS__ = true;

  const it = q.closest('.item');
  const id = it.getAttribute('data-product-id');
  const qty = it.querySelector('.item-qty').value;
  const loader = document.getElementById('ajaxBusy');

  if (qty !== '') loader.style.display = 'block';

  try {
    // 1️⃣ cart qty change
    const change = await fetch(theme.routes_cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ quantity: qty, id })
    }).then(r => r.json());

    // update counter & summ
    document.querySelectorAll('.cartCountSelector')
      .forEach(el => el.textContent = change.item_count);
    const fmt = v => Shopify.formatMoney(v, theme.moneyFormat).replace(/((,00)|(\.00))$/, '');
    document.querySelector('.cartTotalSelector').innerHTML = fmt(change.total_price);
    document.getElementById('total-cart-top').innerHTML = fmt(change.total_price);
    document.getElementById('total-cart-bottom').innerHTML = fmt(change.total_price);

    // 2️⃣ custom sync v2
    try {
      const { updateCartForEngravingsStart } = await import(
        './kb-cart-personalisation-cart-sync.js?v=20260407'
      );
      await updateCartForEngravingsStart();
    } catch (err) {
      console.error('❌ Engraving sync v2 failed:', err);
    }

    // 3️⃣ cart redraw
    const html = await fetch(theme.routes_cart_url).then(r => r.text());
    CartReload(html);

  } catch (err) {
    console.error('❌ CartChange error:', err);
  } finally {
    if (qty === '0') it.remove();
    if (loader) loader.style.display = 'none';
    if (typeof imageObserver === 'function') imageObserver();
    __CART_CHANGE_IN_PROGRESS__ = false;
  }
}

function CartButtons() {
  const container = document.getElementById('cart-table');

  /*  +/-  — немедленный вызов, без debounce  */
  container.querySelectorAll('.qtybtn').forEach(btn => {
    btn.onclick = () => CartChange(btn, container);
  });

  /*  поле ввода количества  */
  container.querySelectorAll('.item-qty').forEach(input => {

    // debounce — срабатывает через 1000ms после последнего нажатия клавиши
    const debouncedChange = debounce(() => CartChange(input, container));
    input.addEventListener('input', debouncedChange);

    // Enter — немедленный вызов, отменяет pending debounce
    input.addEventListener('keydown', e => {
      if (e.keyCode === 13) {
        e.preventDefault();
        debouncedChange.cancel(); // ← отменяем отложенный вызов от input
        CartChange(input, container);
      }
    });
  });
}

theme.CartPage = (function () {
  function CartPage(container) {
    var sectionId = container.getAttribute("data-section-id");
    var chk = container.getAttribute("data-check");
    var rct = container.getAttribute("data-recent");
    var rV = document.getElementById("recently-viewed");
    var rVP = document.getElementById("recently-viewed-placeholder");
    theme.cart = true;
    Quantity(container);
    if (chk == "true") {
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById("cart-terms").onclick = function (ev) {
        if (this.checked == true) {
          nC.classList.remove("outline");
          nC.removeAttribute("disabled");
          nC.setAttribute("aria-label", theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
        } else {
          nC.classList.add("outline");
          nC.setAttribute("disabled", true);
          nC.setAttribute("aria-label", theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
        }
        //b2b data pickler
        document.dispatchEvent(new CustomEvent('b2b:checkout-check'));
      };
    }
    CartButtons(container);
    CartReload(container.innerHTML); // 🔄 Updating product segmentation
    if (rct == "true") {
      function gPD() {
        const pD = JSON.parse(localStorage.getItem("rVP"));
        const rVH = [];
        if (pD) {
          rV.classList.remove("hidden");
          pD.forEach(function (item, i) {
            rVH.push("id:" + item.pID);
          });
          const rB = rVH.join("%20OR%20");
          fetch(theme.routes_search_url + "?&type=product&q=" + rB)
            .then((response) => response.text())
            .then((data) => {
              const parser = new DOMParser();
              const htmlDocument = parser.parseFromString(data, "text/html");
              var rVD = document.querySelector(".recently-viewed");
              var cP = htmlDocument.documentElement.querySelector(
                ".collection-products"
              );
              rVP.remove();
              rVD.appendChild(cP);
              imageObserver();
              if (theme.settings.quickView) {
                Quick();
              }
              Swatches(container);
              if (theme.settings.cart) {
                var sI = htmlDocument.documentElement
                  .querySelector(".search_page")
                  .getAttribute("data-section-id");
                Cart(container, sI);
              }
            })
            .catch(function (err) {
              console.log("!: " + err);
            });
        }
      }
      gPD();
    }
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();
